$(window).on('scroll', function () {
  $('.collectionMainContainer').each(function () {
    const containerTop = $(this).offset().top;
    const containerBottom = containerTop + $(this).outerHeight();
    const scrollTop = $(window).scrollTop();
    const windowHeight = $(window).height();

    // Check if container is in the viewport
    if (scrollTop + windowHeight > containerTop && scrollTop < containerBottom) {
      $(this).addClass('new-class');
      $('body').addClass('scroll_active');
    } else {
      $(this).removeClass('new-class');
      $('body').removeClass('scroll_active');
    }
  });
});


document.addEventListener("DOMContentLoaded", function () {

  const videos = document.querySelectorAll("video");

  // Create an intersection observer
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const video = entry.target;

        if (entry.isIntersecting) {
          // Play the video when it comes onscreen
          video.play().catch(() => {
            // Handle autoplay restrictions (muted videos usually autoplay)
            video.muted = true;
            video.play();
          });
        } else {
          // Pause the video when it goes offscreen
          video.pause();
        }
      });
    },
    { threshold: 0.5 } // Adjust threshold as needed (50% visible)
  );

  // Observe each video
  videos.forEach((video) => observer.observe(video));
});


$(document).ready(function(){

  $(document).on('mouseover', '.menu.header_item .menu-link .child_menu', function(){
    if(!$(this).hasClass('hoveron')){
      $(this).addClass('hoveron');
    }
  })

  $(document).on('mouseout', '.menu.header_item .menu-link .child_menu', function(){
    if($(this).hasClass('hoveron')){
      $(this).removeClass('hoveron');
    }
  })

  $(document).on('mouseover', '.spf-product__swatchs.spf-color-swatch .spf-product__swatch, .product_tab_variants label', function(){
    $(this).trigger('click');

    var variantID = $(this).data('variant-id');
    var $productCard = $(this).closest('.spf-product-card');

 // ✅ GET ORIGINAL PRICE FROM SWATCH
      var originalPrice = $(this).attr('price'); // e.g. 1795

      $('.hidden-products-collection-wrap .hidden-product-item').each(function() {
        var dataVid = $(this).data('vid');

        if (dataVid == variantID) {
          var salePercent = parseFloat($(this).attr('data-sale-percent')) || 0;
          var isSale = $(this).attr('data-sale') === 'true';
          var saleMoney = $(this).attr('data-sale-final-money') || $(this).attr('data-sale-price-money');
          var compareMoney = $(this).attr('data-sale-compare-money') || $(this).attr('data-comp-price-money');
          var regularMoney = $(this).attr('data-sale-price-money');

          if (isSale && salePercent > 0) {
            $productCard.find('.spf-product-card__inner .badge2.badgeFilter').text(salePercent + '% off').show();
            $productCard.find('.spf-product-card__saving').text(salePercent + '% off');
            $productCard.find('.spf-product-card__saleprice.money, .spf-product-card__saleprice').text(saleMoney).show();
            if (compareMoney) {
              $productCard.find('.spf-product-card__oldprice.jjjjjj.money, .spf-product-card__oldprice').text(compareMoney).show();
            } else {
              $productCard.find('.spf-product-card__oldprice.jjjjjj.money, .spf-product-card__oldprice').hide();
            }
          } else {
            $productCard.find('.spf-product-card__saleprice.money, .spf-product-card__saleprice').text(regularMoney).show();
            if (compareMoney) {
              $productCard.find('.spf-product-card__oldprice.jjjjjj.money, .spf-product-card__oldprice').text(compareMoney).show();
            } else {
              $productCard.find('.spf-product-card__oldprice.jjjjjj.money, .spf-product-card__oldprice').hide();
            }
          }
        }
      });

  });


  $('.nav-grid-item').hover(
    function () {
      // Mouse enter
      $('.nav-grid-item .nav-slide-content h3 a').removeClass('add-before');
      $(this).find('.nav-slide-content h3 a').addClass('add-before');
    },
    function () {
      // Mouse leave
      $(this).find('.nav-slide-content h3 a').removeClass('add-before');
    }
  );

});


function applyColorSwatches() {
  if ($('#ProductGridContainer').length > 0) {
    var colors_list = $('.collectionMainContainer').attr('data-colors');

    if (colors_list && colors_list !== 'undefined' && colors_list !== null) {
      var colorArray = colors_list.split(',').map(function(item) {
        var parts = item.split('-');
        return {
          name: parts[0].trim().toLowerCase(),
          hex: parts[1].trim()
        };
      });

      var $colorFilterBox = $('#gf-tree .gf-filter-contents .gf-option-block .gf-block-content .color-filter-gf-box');

      if ($colorFilterBox.length > 0) {
        $colorFilterBox.find('li').each(function () {
          var color_name = $(this).attr('data-color');

          if (color_name && color_name !== 'undefined') {
            var match = colorArray.find(function (color) {
              return color.name === color_name.trim().toLowerCase();
            });

            if (match) {
              $(this).find('.gf-option-value')
                     .css('background-color', match.hex)
                     .addClass('colorSwatchValue');
            }
          }
        });
      }
    }
  }
}


$(window).on('load', function() {
  $('.maincollectionGrid').addClass('show');
  $('.collectionMainContainer .collection-loader').addClass('hide');

  var search_count = 0;

  if($('.template-search .search-product-grid-wrapper').length > 0){
    search_count = $('.template-search .search-product-grid-wrapper .search-product-wrap-inner div#gf-grid span.gf-summary b').text();

    if(search_count > 0){
      $('.template-search__header .template-search__header-content span.search-result-total').text(search_count);
      $('.template-search__header .template-search__header-content .search-header-counter').addClass('showing');
    }
    
  }

  setTimeout(function(){
    /* if ($('div#ProductGridContainer .gf-filter-selection .sort-by').length > 0) {
      if (!$('div#ProductGridContainer .gf-filter-selection .sort-by').hasClass('limit-by')) {
        $('<span class="sortingLabel">Sort By</span>').insertBefore(
          $('div#ProductGridContainer .gf-filter-selection .sort-by').find('.sort-by-toggle')
        );
      }
    } */
    
  }, 1000);
});


window.addEventListener('globoFilterRenderCompleted', function () {
  // If swatches already applied, don't re-run
  if ($('.gf-option-value.colorSwatchValue').length > 0) {
    return;
  }

  applyColorSwatches();

  if ($('.hidden-products-collection-wrap').length > 0 && $('.spf-product-card').length > 0) {
    const hiddenItems = $('.hidden-products-collection-wrap .hidden-product-item');
    const market = $('.hidden-products-collection-wrap').attr('data-market');

    $('.spf-product-card').each(function () {
      const $card = $(this);
      const data_id = $card.attr('data-pid');

      if (data_id && data_id !== 'undefined' && data_id !== null) {
        const $hidden = hiddenItems.filter(`[data-pid="${data_id}"]`);

        if ($hidden.length) {
          const check_if_sale = $hidden.attr('data-sale') === 'true';
          const sale_percent = parseFloat($hidden.attr('data-sale-percent')) || 0;
          const sale_title = $hidden.attr('data-sale-title') || '';
          const sale_money = $hidden.attr('data-sale-final-money') || $hidden.attr('data-sale-price-money');
          const compare_money = $hidden.attr('data-sale-compare-money') || $hidden.attr('data-comp-price-money');
          const regular_money = $hidden.attr('data-sale-price-money');

          if(sale_percent > 0 && check_if_sale == true){
            $(this).find('span.badge.badge2.badgeFilter').html(sale_percent+'% off').show();
          }

          if (check_if_sale && sale_percent > 0) {
            $card.find('.spf-product-card__saleprice').html(sale_money).show();
            if (compare_money) {
              $card.find('.spf-product-card__oldprice').html(compare_money).show();
            } else {
              $card.find('.spf-product-card__oldprice').hide();
            }
            $card.find('.spf-product-card__saving').html(`${sale_percent}% off`);
          } else {
            $card.find('.spf-product-card__saleprice').html(regular_money).show();
            if (compare_money) {
              $card.find('.spf-product-card__oldprice').html(compare_money).show();
            } else {
              $card.find('.spf-product-card__oldprice').hide();
            }
            $card.find('.spf-product-card__saving').html('');
          }

          // Optional: Add sale title tooltip or badge
          if (sale_title) {
            $card.attr('data-sale-title', sale_title);
          }
        }
      }

      if(market == 'canada'){
        $(this).find('.spf-product__swatchs .spf-product__swatch[data-option-value="Ash"]').hide();
        $(this).find('.spf-product__swatchs .spf-product__swatch[data-option-value="Nightfall"]').hide();
      }

    });

  }
});

// 22may
function updateMemorialSaleBar(cartTotal, cart) {

  const saleBar = document.querySelector(".cart_drawer_free_shipping_bar");
  const currency = (
    (cart && cart.currency) ||
    (window.Shopify && window.Shopify.currency && (window.Shopify.currency.active || window.Shopify.currency.isoCode)) ||
    ''
  ).toUpperCase();
  const isUKMarket = currency === 'GBP' || window.location.hostname.indexOf('uk.') === 0;
  const liquidGoal = Number(saleBar?.dataset.saleGoal) || 0;
  const maxGoal = liquidGoal || (isUKMarket ? 650 : 750);
  const defaultAwayTemplate = isUKMarket
    ? `You're £__REMAIN__ away from <strong>£50 OFF</strong>`
    : `You're $__REMAIN__ away from <strong>$100 OFF</strong>`;
  const defaultUnlockedMessage = isUKMarket
    ? `🎉 Congratulations! You've unlocked <strong>£50 OFF</strong>`
    : `🎉 Congratulations! You've unlocked <strong>$100 OFF</strong>`;
  const liquidMessageMatchesMarket = Boolean(
    saleBar?.dataset.saleGoal &&
    ((isUKMarket && liquidGoal === 650) || (!isUKMarket && liquidGoal === 750))
  );
  const awayTemplate = (liquidMessageMatchesMarket && saleBar?.dataset.awayTemplate) || defaultAwayTemplate;
  const unlockedMessage = (liquidMessageMatchesMarket && saleBar?.dataset.unlockedMessage) || defaultUnlockedMessage;

  const fill = document.getElementById("saleProgressFill");
  const icon = document.getElementById("saleProgressIcon");
  const message = document.getElementById("progressMessage");
  const congratsBox = document.getElementById("saleCongratsBox");
  const milestoneLabel = document.querySelector(".milestone-label.milestone-150");
  const almostThereText = congratsBox ? congratsBox.querySelector("p") : null;

  if (!fill || !icon || !message) return;

  if (milestoneLabel) {
    milestoneLabel.textContent = isUKMarket ? '£50 off' : '$100 off';
  }

  if (almostThereText) {
    almostThereText.innerHTML = isUKMarket
      ? `<span class="cong-text-icon"> <img src="https://cdn.shopify.com/s/files/1/0745/0876/3427/files/Check.svg?v=1779447072" alt="Icon"> </span> <strong>Almost there!</strong> Spend £650 to get £50 off.`
      : `<span class="cong-text-icon"> <img src="https://cdn.shopify.com/s/files/1/0745/0876/3427/files/Check.svg?v=1779447072" alt="Icon"> </span> <strong>Almost there!</strong> Spend $750 to get $100 off.`;
  }

  /* Progress Percentage */
  let fillPercent = (cartTotal / maxGoal) * 100;

  fillPercent = Math.max(0, Math.min(fillPercent, 100));

  /* Apply progress */
  fill.style.width = `${fillPercent}%`;
  icon.style.left = `${fillPercent}%`;

  /* Dynamic market messages */

  if (cartTotal < maxGoal) {
    const remain = Math.max(0, Math.ceil(maxGoal - cartTotal));
    message.innerHTML = awayTemplate.replace('__REMAIN__', remain.toLocaleString());

    if (congratsBox) {
      congratsBox.style.display = "flex";
    }

  }else {
    message.innerHTML = unlockedMessage;
    if (congratsBox) {
      congratsBox.style.display = "none";
    }
  }
}

/* Fetch Shopify Cart */
function initMemorialProgressBar() {

  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {

      /* Shopify returns cents */
      let cartTotal = cart.total_price / 100;

      let itemsTotalPrice = cart.items_subtotal_price / 100;

      let free_shipping_bar = $('.cart_drawer_free_shipping_bar');

      if(free_shipping_bar){
        free_shipping_bar.attr('cart-items', cart.item_count);
      }

      updateMemorialSaleBar(itemsTotalPrice, cart);

    })
    .catch(error => {
      console.log('Cart Error:', error);
    });

}

/* Initial Load */
document.addEventListener("DOMContentLoaded", function () {
  initMemorialProgressBar();
});

/* Recalculate after ANY cart AJAX update */

(function() {

  const originalFetch = window.fetch;

  window.fetch = async function() {

    const response = await originalFetch.apply(this, arguments);

    const url = arguments[0];

    if (
      typeof url === 'string' &&
      (
        url.includes('/cart/add') ||
        url.includes('/cart/change') ||
        url.includes('/cart/update') ||
        url.includes('/cart/clear')
      )
    ) {

      setTimeout(() => {
        initMemorialProgressBar();
      }, 300);

    }

    return response;
  };

})();

document.querySelectorAll('.product_tab_variants label').forEach(label => {
  label.addEventListener('mouseenter', () => {
    document
      .querySelectorAll('.product_tab_variants label')
      .forEach(el => el.classList.remove('is-selected'));

    label.classList.add('is-selected');
  });
});

document.addEventListener('click', function(e){
    if(e.target.closest('.gf-close-canvas')){
        if(window.globofilter && globofilter.toggleCanvas){
            globofilter.toggleCanvas();
        }
    }
});